import { DEFAULT_PAGE } from '../../constants/pagination';
import {
  REPORTSMANAGEMENT_DEFAULT_SORT_COLUMN,
  REPORTSMANAGEMENT_DEFAULT_SORT_ORDER,
} from '../../constants/sort';
import { SortOrder } from '../sort/sort';

export interface ReportManagementGetQueryParams {
  page: number;
  sortOrder: SortOrder;
  sortKey: string;
  employeeId: number | null;
  projectId: number | null;
  month: string | null;
}

export const DefaultReportManagementGetQueryParams: ReportManagementGetQueryParams =
  {
    page: DEFAULT_PAGE,
    sortOrder: REPORTSMANAGEMENT_DEFAULT_SORT_ORDER,
    sortKey: REPORTSMANAGEMENT_DEFAULT_SORT_COLUMN,
    projectId: null,
    employeeId: null,
    month: null,
  };
